module.exports = __webpack_public_path__ + "img/ic_hotel_card_arrow_right.2da12ba9.svg";